import React from 'react';
import { mockData } from './data';
import { CalendarIcon } from 'lucide-react';
import { motion } from 'framer-motion';
interface KpiProps {
  label: string;
  value: string;
  unit: string;
  valueColor?: string;
  borderClass?: string;
}
function Kpi({
  label,
  value,
  unit,
  valueColor = 'text-[#0A1F5C]',
  borderClass = ''
}: KpiProps) {
  return <div className={`p-6 flex flex-col items-center text-center ${borderClass}`} data-id="element-425">
      <span className="text-[10px] font-bold text-[#0A1F5C] uppercase tracking-wider mb-2" data-id="element-426">
        {label}
      </span>
      <span className={`text-5xl font-bold tabular-nums tracking-tight ${valueColor}`} data-id="element-427">
        {value}
      </span>
      <span className="text-[10px] font-semibold text-gray-500 mt-1 uppercase tracking-wider" data-id="element-428">
        {unit}
      </span>
    </div>;
}
export function TodaySnapshot() {
  return <motion.section initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.4
  }} className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden h-full flex flex-col" data-id="element-429">
      <div className="bg-[#0A1F5C] text-white px-4 py-2.5 flex justify-between items-center" data-id="element-430">
        <div className="flex items-center gap-2 font-semibold text-sm tracking-wide" data-id="element-431">
          <CalendarIcon className="w-4 h-4" data-id="element-432" />
          TODAY'S SCORECARD
        </div>
        <div className="text-xs font-medium text-blue-100" data-id="element-433">
          {mockData.user.date}
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 flex-1" data-id="element-434">
        <Kpi label="Today's Points" value={mockData.today.points} unit="Points" data-id="element-435" />
        <Kpi label="Remaining Today" value={mockData.today.remaining} unit="Points" valueColor="text-[#16A34A]" borderClass="md:border-l border-gray-100" data-id="element-436" />
        <Kpi label="Days Left In Month" value={mockData.today.daysLeft} unit="Days" borderClass="border-t md:border-t-0 md:border-l border-gray-100" data-id="element-437" />
        <Kpi label="Daily Target" value={mockData.today.dailyTarget} unit="Points / Day" borderClass="border-t md:border-t-0 md:border-l border-gray-100" data-id="element-438" />
      </div>
    </motion.section>;
}